import { AxiosAdapter, UserAdapter } from '@adapters';
import { CheckIdDuplicateUsecase } from '@core/useCases';
import { useAlertStore } from '@stores';
import { isWebId } from '@core/utils';

export const useCheckIdDuplicate = () => {
  const axiosAdapter = new AxiosAdapter();
  const userAdapter = new UserAdapter(axiosAdapter);
  const checkIdDuplicateUsecase = new CheckIdDuplicateUsecase(userAdapter);
  const alertStore = useAlertStore();

  const handleCheckIdDuplicate = async (
    webId: string,
    minLength = 4,
    maxLength = 12
  ) => {
    if (webId === '') {
      await alertStore.showAlertDialog('아이디를 입력해주세요');
      return false;
    }
    if (!isWebId(webId, minLength, maxLength)) {
      await alertStore.showAlertDialog(
        `아이디는 영문이나 영문+숫자로 <br />${minLength}~${maxLength}자 이내로 입력해주세요.`
      );
      return false;
    }
    return await checkIdDuplicateUsecase.execute(webId);
  };

  return {
    handleCheckIdDuplicate,
  };
};
